import { render, staticRenderFns } from "./ProducerEdition.vue?vue&type=template&id=1f29d3cc&"
import script from "./ProducerEdition.vue?vue&type=script&lang=js&"
export * from "./ProducerEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports